<template>
  <!-- Wishlist-Page -->
  <div style="height : 100px" v-if="status.wishlist.loading">
    <Spinner text="Please Wait.." />
  </div>
  <div class="page-wishlist u-s-p-t-80" v-if="!status.wishlist.loading && getWishListItems.length != 0">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <!-- Products-List-Wrapper -->
          <div class="table-wrapper u-s-m-b-60">
            <table>
              <thead>
                <tr>
                  <th>Product</th>
                  <th>Warehouse</th>
                  <th>Unit Price</th>
                  <th>Stock Status</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <WishlistProduct v-for="wishlistItem in getWishListItems" :key="wishlistItem.id" :wishlistItem="wishlistItem" />
              </tbody>
            </table>
          </div>
          <!-- Products-List-Wrapper /- -->
        </div>
      </div>
    </div>
  </div>

  <div class="page-cart u-s-p-t-80" v-if="!status.wishlist.loading && getWishListItems.length == 0" >
    <div class="page-cart">
      <div class="">
        <div class="text-center">
          <h1>Em <i class="fas fa-child"></i>ty!</h1>
          <h5>Your wishlist is currently empty.</h5>
          <div class="redirect-link-wrapper u-s-p-t-25">
            <a class="redirect-link" href="/">
              <span>Return to Shop</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Wishlist-Page /- -->
</template>

<script>
import WishlistProduct from "./WishlistProduct.vue";
import { mapActions, mapGetters } from "vuex";
import Spinner from "../Loaders/Spinner.vue"
export default {
  components: { WishlistProduct, Spinner },
  computed: { ...mapGetters("wishlist", ["getWishListItems", "status"]) },
  methods: { ...mapActions("wishlist", ["fetchWishlist"])},
  mounted() {
    this.fetchWishlist();
  },
};
</script>

<style>
</style>